import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { homeFor } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

export function startGoogleLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google", { session_id: sessionId })
      .then(({ data }) => { setUser(data); navigate(homeFor(data.role), { replace: true }); })
      .catch((e) => { setUser(false); setError(errMsg(e)); });
  }, [navigate, setUser]);

  if (!error) return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-5">
      <div className="card-surface max-w-md p-8 text-center" data-testid="google-login-error">
        <div className="font-display text-xl font-bold text-slate-900">Accesso con Google non riuscito</div>
        <p className="mt-2 text-sm text-slate-600">{error}</p>
        <button onClick={() => navigate("/login", { replace: true })} className="mt-6 rounded-lg bg-[#0F2042] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#1E3A8A]" data-testid="google-error-back-btn">Torna all'accesso</button>
      </div>
    </div>
  );
}
